import { library } from "@fortawesome/fontawesome-svg-core"

import {
  // faArrowUpRightFromSquare,
  // faBagShopping,
  //   faCartShopping,
  faEnvelopeOpen,
  faIdCard,
  faLink,
  faNewspaper,
  faPodcast,
  faThumbsUp
  // faSquareArrowUpRight
} from "@fortawesome/free-solid-svg-icons"

import {
  faAmazon,
  faApple,
  faBandcamp,
  faDev,
  faDiscord,
  faDribbble,
  faEtsy,
  faFacebook,
  faFacebookF,
  faGithub,
  faGooglePlay,
  faInstagram,
  faItunesNote,
  faLinkedin,
  faLinkedinIn,
  faMediumM,
  faPatreon,
  faPinterestP,
  faRedditAlien,
  faSlack,
  faSnapchatGhost,
  faSpotify,
  faSoundcloud,
  faSquareThreads,
  faSquareXTwitter,
  faTelegramPlane,
  faTiktok,
  faTumblr,
  faTwitch,
  faTwitter,
  faVimeo,
  faXTwitter,
  faYoutube,
  faThreads
} from "@fortawesome/free-brands-svg-icons"

// Fontawesome solid icons
library.add(
  // faArrowUpRightFromSquare,
  // faBagShopping,
  // faCartShopping,
  faEnvelopeOpen,
  faIdCard,
  faLink,
  faNewspaper,
  faPodcast,
  // faSquareArrowUpRight,
  faThumbsUp
)

// Fontawesome brand icons
library.add(
  faAmazon,
  faApple,
  faBandcamp,
  faDev,
  faDiscord,
  faDribbble,
  faEtsy,
  faFacebook,
  faFacebookF,
  faGithub,
  faGooglePlay,
  faInstagram,
  faItunesNote,
  faLinkedin,
  faLinkedinIn,
  faMediumM,
  faPatreon,
  faPinterestP,
  faRedditAlien,
  faSlack,
  faSnapchatGhost,
  faSpotify,
  faSoundcloud,
  faSquareThreads,
  faSquareXTwitter,
  faTelegramPlane,
  faTiktok,
  faTumblr,
  faTwitch,
  faTwitter,
  faVimeo,
  faXTwitter,
  faYoutube,
  faThreads
)
